export const constants = {
  mobileNumber: "‭07760 247029‬",
  landlineNumber: "01698 372048",
  email: "stevenson-roofing@outlook.com",
}
